import DateUtils from "../../../utils/DateUtils.js";

export default function DisplayDayIso(props) {
  const { date } = props;

  return DateUtils.localDateToTimelessIsoString(new Date(date));
}
